import { application } from './application.js'

import ClipboardController from './clipboard_controller.js';
import DebouncedSearchController from './debounced_search_controller.js';
import DistributorsChangeDistributorController from './distributors/change_distributor_controller.js';
import DistributorsInvestorAutocompleteController from './distributors/investor_autocomplete_controller.js';
import DistributorsSubscriptionModalController from './distributors/subscription_modal_controller.js';
import FormSubmitController from './form_submit_controller.js';
import NavbarController from './navbar_controller.js';
import OpenedModalController from './opened_modal_controller.js';
import PayoutAmountController from './payout_amount_controller.js';
import PerformanceChartController from './performance_chart_controller.js';
import ProjectsCarouselController from './projects_carousel_controller.js';
import RentalIncomeChartController from './rental_income_chart_controller.js';
import ReservationController from './reservation_controller.js';
import RowLinkController from './row_link_controller.js';

application.register('clipboard', ClipboardController);
application.register('debounced-search', DebouncedSearchController);
application.register('change-distributor', DistributorsChangeDistributorController);
application.register('investor-autocomplete', DistributorsInvestorAutocompleteController);
application.register('subscription-modal', DistributorsSubscriptionModalController);
application.register('form-submit', FormSubmitController);
application.register('navbar', NavbarController);
application.register('opened-modal', OpenedModalController);
application.register('payout-amount', PayoutAmountController);
application.register('performance-chart', PerformanceChartController);
application.register('projects-carousel', ProjectsCarouselController);
application.register('rental-income-chart', RentalIncomeChartController);
application.register('reservation', ReservationController);
application.register('row-link', RowLinkController);
